import ajax from "./ajax";
import context from "./context";

class Security {
    constructor() {
    }

    /**
     * NOTE : for entityType="Placement", entityId=`${offSysId}_${placementId}`
     * @param {*} entityType 
     * @param {*} entityId 
     * @param {*} claims 
     * @returns 
     */
    assertClaimOnEntityAsync(entityType, entityId, claims) {
        if (claims == null) throw new Error("claims cannot be null or undefined");
        let _claims = null;

        if (Array.isArray(claims)) {
            _claims = claims.reduce((s, v) => {
                s[v] = "";
                return s;
            }, {});
        } else if (typeof (claims) === "object") {
            if (claims.constructor.prototype === Map.prototype) {
                _claims = {};
                for (const kvp of claims) _claims[kvp[0]] = kvp[1] || "";
            } else _claims = claims;
        } else {
            _claims = {};

            if (claims && claims.toString().trim()) {
                _claims = {
                    [claims.toString()]: ""
                }
            }
        }

        return ajax.security().post("assert-claim-on-entity", { entityType, entityId, claims: _claims});
    }

    /**
     * Assertion manner
     * - Demand all, user must have all demanded claims
     * - Deny any, user get denied if he/she has any of denied claims
     * @param {Object | Map<string, string> | string[] | string} claims 
     * @returns {Promise<boolean>}
     */
    assertAsync(claims, action) {
        if (claims == null) throw new Error("claims cannot be null or undefined");
        let _claims = null;

        if (Array.isArray(claims)) {
            _claims = claims.reduce((s, v) => {
                s[v] = "";
                return s;
            }, {});
        } else if (typeof (claims) === "object") {
            if (claims.constructor.prototype === Map.prototype) {
                _claims = {};
                for (const kvp of claims) _claims[kvp[0]] = kvp[1] || "";
            } else _claims = claims;
        } else {
            _claims = {};

            if (claims && claims.toString().trim()) {
                _claims = {
                    [claims.toString()]: ""
                }
            }
        }

        return ajax.security().post("assert", { claims: _claims, action });
    }

    /**
     * 
     * @param {string} href 
     */
    assertHrefAccessAysnc(href) {
        return ajax.security().post("assert-href", { href });
    }

    assertAccessToEntity(entityType, entityId) {
        return ajax.security().post("assert-access-to-entity", { entityType, entityId });
    }

    getTrackedHrefAsync() {
        return ajax.security().get("tracked-href");
    }

    ensureHasAccessToHref(href) {
        console.debug("Assert Href", href);
        this.assertHrefAccessAysnc(href)
            .then(r => {
                if (!r.data.success) {
                    window.location = context.routeUrl(`home?msg=${encodeURI("Access denied")}`);
                }
            });
    }
}

const security = new Security();

export function securityRouteUpdateHandler(routes) {    
    if (routes) {
        const route = routes.length > 0 ? routes[routes.length - 1] : null;
        if (route) {
            const href = route.path ? route.path.toLowerCase() : null;
            const trackedHref = context.trackedHref();
            if (href && trackedHref.has(href.toLowerCase())) {
                security.ensureHasAccessToHref(href);
            }
        }
    }
}

export default security;